import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import minilogo from "../../../assets/images/logo-small.svg";
import logo from "../../../assets/images/logo-big.svg";
import arrowwithgreenbg from "../../../assets/images/arrow-with-green-bg.svg";
import dashboard from "../../../assets/images/icons/dashboard.svg";
import bookings from "../../../assets/images/icons/bookings.svg";
import colleagues from "../../../assets/images/icons/colleagues.svg";
import suitcase from "../../../assets/images/icons/suitcase.svg";
import settings from "../../../assets/images/icons/settings.svg";
import map from "../../../assets/images/icons/minimap.svg";
import EditSquare from "../../../assets/images/icons/edit-square.svg";

export default function Sidebar() {
    const sidebarRef = useRef(null);
    const { t } = useTranslation();
    const location = useLocation();

    // New: State to manage sidebar's expanded/collapsed state
    const [isSidebarActive, setIsSidebarActive] = useState(true);

    const menuItems = [
        { to: "/booking", textKey: "Home", icon: bookings, tooltip: "My bookings" },
        { to: "/calendar", textKey: "Calendar", icon: dashboard, tooltip: "Calendar" },
        { to: "/mapcanvas", textKey: "Map", icon: map, tooltip: "Map" },
        { to: "/newbooking", textKey: "New Booking", icon: EditSquare, tooltip: "New Booking" },
        { to: "/colleagues", textKey: "Find colleagues", icon: colleagues, tooltip: "Find colleagues" },
        { to: "/roles", textKey: "Employee roles", icon: suitcase, tooltip: "Employee roles" },
        { to: "/setting", textKey: "Profile", icon: settings, tooltip: "Settings" },
    ];

    // Refactored useEffect to toggle state instead of DOM classes
    useEffect(() => {
        const menu_btn = document.querySelector("#menu-btn");
        const container = document.querySelector(".my-container");

        const handleMenuClick = () => {
            setIsSidebarActive(prevState => !prevState);
            if (container) {
                container.classList.toggle("active-cont");
            }
        };

        if (menu_btn) {
            menu_btn.addEventListener("click", handleMenuClick);
        }

        return () => {
            if (menu_btn) {
                menu_btn.removeEventListener("click", handleMenuClick);
            }
        };
    }, []);

    return (
        <div
            className={`side-navbar d-flex flex-wrap flex-column justify-content-between ${isSidebarActive ? "active-nav" : ""}`}
            id="sidebar"
            ref={sidebarRef}
        >
            {/* <a href="#" className="nav-link text-center pt-4 logo">
                {isSidebarActive ? (
                    <img src={logo} alt="Full Logo" className="img-fluid logo" />
                ) : (
                    <img src={minilogo} alt="Mini Logo" className="img-fluid logo" />
                )}
            </a> */}

            <a href="#" className="nav-link text-center pt-4 logo">
  <div className={`logo-container ${isSidebarActive ? "expanded" : "collapsed"}`}>
    <img
      src={isSidebarActive ? logo : minilogo}
      alt="Logo"
      className="img-fluid"
    />
  </div>
</a>

            <div className="pb-3 open-close">
                <a className="btn border-0" id="menu-btn">
                    <img src={arrowwithgreenbg} alt="" />
                </a>
            </div>
            <div id="accordian" className="flex-grow-1">
                <ul className="show-dropdown menu-style">
                    {menuItems.map((item) => (
                        <li
                            key={item.to}
                            className={location.pathname === item.to ? "active" : ""}
                        >
                            <NavLink
                                to={item.to}
                                data-tooltip={item.tooltip}
                            >
                                <img src={item.icon} alt="" />
                                <span>{t(item.textKey)}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
